export const inputCharactersLimitText = 'You can type up to 1000 characters';
export const disclaimerText =
  'AI-generated responses may be inaccurate or incomplete. Users are responsible for reviewing and validating information before use.';
